import React from "react";
import { SectionArticle } from "../../shared/ArticleTemplate";

const History = ({parentPath}) =>
  <SectionArticle sectionName="history" backRoute={parentPath}/>

export default History;